<div class="flex-fill d-flex flex-column">
  <div class="flex-fill content-block">
    <div class="d-flex flex-fill flex-column">
      <dx-data-grid
        #overviewGrid
        keyExpr="id"
        class="d-flex flex-fill flex-column"
        [height]="'650px'"
        [dataSource]="serviceAddresses"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowDblClick)="rowDoubleClick($event)"
        >
        <dxi-data-grid-column dataField="gridName" caption="Site Name" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="phone" width="95"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="range" width="95"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="address1" width="250"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="address2" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="city" width="200"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="state" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="zip" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="county" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="distance" caption="Job Dist." width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="latitude" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="longitude" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="notes" width="250"></dxi-data-grid-column>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="service-address-grid"></dxo-data-grid-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'">
          @if (!readonly) {
            <span>
              <button class="btn btn-success me-2 mb-2" (click)="open()">Add</button>
              <button
                class="btn btn-primary me-2 mb-2"
                (click)="open(overviewGrid.instance.getSelectedRowsData()[0])"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length !== 1"
                >
                Open
              </button>
              <button
                class="btn btn-danger me-4 mb-2"
                (click)="delete(overviewGrid.instance.getSelectedRowsData()[0])"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length !== 1"
                >
                Delete
              </button>
              <button
                class="btn btn-success mb-2"
                (click)="getDirections(overviewGrid.instance.getSelectedRowsData()[0])"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length !== 1"
                >
                Get Directions
              </button>
            </span>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (serviceAddresses) {
            <span class="me-3">
              <strong>{{ overviewGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
